<template>
  <div>
    <v-flex shrink class="row">
      <Base--InlineTextBlock>
        Мультиплеер:
      </Base--InlineTextBlock>
      <div>
        <v-text-field
          v-model="multiplier"
          class="multiplier-input"
          mask="0.###"
        />
      </div>
    </v-flex>
    <dice-statistics-table />
    <BaseSideButtons :save="save" back />
  </div>
</template>

<script>
import BaseSideButtons from '../Base--SideButtons'
import { getMultiplier, updateMultiplier } from '../../../api/dice'
import DiceStatisticsTable from '../common/Table/DiceStatisticsTable/DiceStatisticsTable'

export default {
  name: 'Dice',
  components: { DiceStatisticsTable, BaseSideButtons },
  data () {
    return {
      multiplier: 0.01
    }
  },
  mounted () {
    getMultiplier().then(resp => {
      this.multiplier = resp.data.multiplier.toString()
    })
  },
  methods: {
    save () {
      const multiplier = Number.parseFloat(`${this.multiplier.substring(0, 1)}.${this.multiplier.substring(1, 4)}`)
      if (multiplier <= 0.1 && multiplier >= 0.01) this.AxiosHelperShowResponce(updateMultiplier(multiplier))
      else this.$store.dispatch('showErrorMessage', 'error. multiplier <= 0.1 or multiplier >= 0.01!!')
    }
  }
}
</script>

<style scoped>
    .row {
        display: flex;
        padding-top: 10px;
    }

    .row .title {
        padding-top: 8px;
    }

    .multiplier-input {
        margin: 0;
        padding: 0;
        width: 45px !important;
    }
</style>
